export const addPartnerIdToIdentityHubModule = () => {
    // access pwt pbjs and que function
    window.wb_web_ihowpbjs = window.wb_web_ihowpbjs || { que: [] };

    // run only when pwt pbjs is ready
    window.wb_web_ihowpbjs?.que?.push(function() {
        // get user sync config from pwt pbjs
        const userSync = window.wb_web_ihowpbjs?.getConfig('userSync');

        // override liveintentid config
        if (userSync?.userIds) {
            userSync.userIds = userSync.userIds?.map?.((config: any) => {
                const cfg = config?.name === 'liveIntentId' ? {
                    ...config,
                    params: {
                        ...config.params,
                        requestedAttributesOverrides: {
                            ...config.params.requestedAttributesOverrides, 
                            magnite: true  
                        }
                    }
                } : config;

                return cfg;
            });

            // set user sync config in pwt pbjs
            window?.wb_web_ihowpbjs?.setConfig?.({ userSync });
        }
    });
};

export const setPrebidEventListeners = (eventType: 'on' | 'off', eventHandler: (adUnits: any) => void): void => {
    if (!eventHandler) {
        return;
    }
    if (eventType === 'on') {
        window.pbjs?.que?.push(() => {
            window.pbjs?.onEvent?.('beforeRequestBids', eventHandler);
        });
        return;   
    }

    if (eventType === 'off') {
        window.pbjs?.que?.push(() => {
            window.pbjs?.offEvent?.('beforeRequestBids', eventHandler);
        });
        return;   
    }
};
export const setPrebidErrorEventListeners = (eventType: 'on' | 'off', eventHandler: (...params: any[]) => void): void => {
    if (!eventHandler) {
        return;
    }
    if (eventType === 'on') {
        window.pbjs?.que?.push(() => {
            window.pbjs?.onEvent?.('adRenderFailed', eventHandler);
        });
        return;   
    }

    if (eventType === 'off') {
        window.pbjs?.que?.push(() => {
            window.pbjs?.offEvent?.('adRenderFailed', eventHandler);
        });
        return;   
    }
};

